interface IProps {
    width?: number;
    height?: number;
    color?: string;
}

export const LoadingSpinner = (props: IProps) => {
    const {width = 16, height = 16, color = "#FCFCFC"} = props;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            className="animate-spin"
        >
            <circle
                cx="12"
                cy="12"
                r="10"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeDasharray="15.708"
                strokeDashoffset="15.708"
                className="opacity-25"
            />
            <circle
                cx="12"
                cy="12"
                r="10"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeDasharray="15.708"
                strokeDashoffset="11.781"
                className="opacity-75"
            />
        </svg>
    );
};
